export default "__VITE_ASSET__CxUoV4Hf__"